import React from 'react'

export default function TravelTour() {
  return (
    <div>
     <div className="all-header-bg">
        <div
          className="all-header-overlay"
        >
          <div className="container">
            <div className="row d-flex align-items-center justify-content-center py-6">
              <div className="col-md-6 less-padding-Top">
                <h1 className="head animate__animated animate__zoomIn text-white">
                  Travel & Tour
                </h1>
                <p className="text-white">Welcome to Immiconsult Pvt Ltd, your trusted partner in navigating the complex world of visa immigration with precision, expertise, and care.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
